import apiConfig from './api';
import ssoConfig from './sso';
import uiConfig from './ui';

const ENV = process.env.NODE_ENV === 'development' ? 'dev' : 'prod' ;
const CONFIG_GLOBAL = "global";

function bind(config){
    return { ...config[CONFIG_GLOBAL], ...config[ENV] }
}

export default {
    ENV: ENV,
    DEV: ENV === "dev",
    PROD: ENV === "prod",
    API: bind(apiConfig),
    SSO: bind(ssoConfig),
    UI: bind(uiConfig)
}


// WEBPACK FOOTER //
// ./src/config/index.js